import React from 'react';
import { Modal, View } from 'react-native-web';
import GLOBAL from '../configs/config_global';

export function CustomModal(props) {
    const { visible, children, onShow = () => {}, onDismiss = () => {} } = props;
    return(
        <Modal
            visible={visible}
            animationType={'fade'}
            transparent={true}
            onShow={onShow}
            onDismiss={onDismiss}>
            <View style={{ flex: 1, width: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                <View style={{ flex: 1, margin: 128, borderWidth: 2, borderRadius: 16, borderColor: GLOBAL.COLOR.DIVIDER, overflow: 'hidden', backgroundColor: 'white' }}>
                    {children}
                </View>
            </View>
        </Modal>
    );
}
